import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const it = {
  translation: {
    nav: { blog: "Blog", events: "Eventi", franchise: "Franchising", courses: "Corsi", sedi: "Sedi", pricing: "Pacchetti" },
    common: { login: "Accedi", register: "Registrati", logout: "Esci", dashboard: "Area personale", loading: "Caricamento…", cancel: "Annulla", save: "Salva", submit: "Invia" },
    hero: {
      eyebrow: "Puglia · Movimento · Metodo",
      title_1: "Il tuo spazio di", title_2_a: "movimento, equilibrio", title_2_b: "e energia positiva.",
      body: "Lezioni di Pilates in studio e all'aperto, per ritrovare forza, postura e armonia in ogni stagione.",
      cta_book: "Prenota la tua lezione", cta_courses: "Scopri i corsi",
      classes_label: "Classi", classes_value: "2 · 6 persone", classes_note: "A numero chiuso, seguite con cura.",
    },
    method: {
      eyebrow: "Il metodo", title_1: "Ogni corpo è diverso.", title_2: "Per questo ogni percorso lo è.",
      body: "Epic Flow nasce dalla visione di Eliza Muresan: rendere il Pilates accessibile, sicuro e davvero efficace per ogni fase della vita. Un metodo che unisce tecnica, ascolto e personalizzazione.",
      claim_1: "Non è un semplice Pilates.", claim_2: "È un metodo.",
    },
    features: {
      title: "Perché scegliere Epic Flow",
      items: [
        "Classi a numero chiuso (max 2-6 persone) per seguire ogni movimento con cura",
        "Attrezzi professionali: Reformer, Cadillac, Aereo, Barre",
        "Massima flessibilità di prenotazione tramite APP",
        "Ambiente accogliente e specializzato, adatto anche a chi non ha mai fatto Pilates",
        "Percorsi mirati per gravidanza, senior e problematiche fisiche comuni",
      ]
    },
    coming_soon: {
      eyebrow: "Coming soon",
      title: "Epic Flow sta arrivando a Polignano a Mare!",
      body: "A Polignano a Mare sta arrivando il primo studio di Pilates targato Epic Flow.",
      cta: "Scopri di più",
    },
  }
};

const en = {
  translation: {
    nav: { blog: "Blog", events: "Events", franchise: "Franchising", courses: "Classes", sedi: "Studios", pricing: "Plans" },
    common: { login: "Sign in", register: "Sign up", logout: "Log out", dashboard: "My area", loading: "Loading…", cancel: "Cancel", save: "Save", submit: "Submit" },
    hero: {
      eyebrow: "Puglia · Movement · Method",
      title_1: "Your space of", title_2_a: "movement, balance", title_2_b: "and positive energy.",
      body: "Pilates classes indoor and outdoor, to regain strength, posture and harmony in every season.",
      cta_book: "Book your lesson", cta_courses: "Discover the classes",
      classes_label: "Classes", classes_value: "2 · 6 people", classes_note: "Small groups, followed with care.",
    },
    method: {
      eyebrow: "The method", title_1: "Every body is different.", title_2: "That's why every path is too.",
      body: "Epic Flow is born from Eliza Muresan's vision: make Pilates accessible, safe and truly effective for every phase of life. A method that unites technique, listening and personalisation.",
      claim_1: "It's not just Pilates.", claim_2: "It's a method.",
    },
    features: {
      title: "Why choose Epic Flow",
      items: [
        "Small classes (max 2-6 people) to guide every movement with care",
        "Professional apparatus: Reformer, Cadillac, Aerial, Barre",
        "Full booking flexibility via the app",
        "Warm, specialised studio, welcoming even to complete beginners",
        "Dedicated paths for pregnancy, seniors and common physical needs",
      ]
    },
    coming_soon: {
      eyebrow: "Coming soon",
      title: "Epic Flow is coming to Polignano a Mare!",
      body: "The first Epic Flow Pilates studio is opening in Polignano a Mare.",
      cta: "Learn more",
    },
  }
};

// In alcuni contesti (Safari privato, browser molto vecchi, SSR-like con
// window ma senza storage abilitato) `localStorage.getItem` può lanciare
// SecurityError. Meglio degradare al fallback anziché crashare l'init.
function readSavedLang() {
  try {
    return localStorage.getItem("ef_lang") || "it";
  } catch {
    return "it";
  }
}

i18n.use(initReactI18next).init({
  resources: { it, en },
  lng: readSavedLang(),
  fallbackLng: "it",
  interpolation: { escapeValue: false },
});

export default i18n;
